import { customer } from './data/data';

export default {
  get() {
    return [200, customer];

    // error: タイムアウト
    // return [408, { message: 'タイムアウトしました' }];
  }
};
